import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GeckoBtn } from '../../ui';
import './index.scss';

class LoadMore extends Component {
  static propTypes = {
    onNewItems: PropTypes.func.isRequired,
    loadItems: PropTypes.func.isRequired,
    moreToLoad: PropTypes.bool.isRequired,
  };

  state = {
    isLoading: false,
  };

  startLoadingItems() {
    this.setState({ isLoading: true });
    return new Promise((resolve) => resolve())
      .then(this.props.loadItems)
      .then((newItems) => {
        this.setState({ isLoading: false });
        this.props.onNewItems(newItems);
      })
      .catch((err) => {
        this.setState({ isLoading: false });
      });
  }

  render() {
    if (!this.props.moreToLoad) {
      return null;
    }
    return (
      <div className="LoadMore">
        <GeckoBtn
          handler={() => this.startLoadingItems()}
          disabledWhen={() => this.state.isLoading}
          name="Load More"
        />
      </div>
    );
  }
}

export default LoadMore;
